export default {
    SalesOrderToBeApproved: {
        Pending: 'Pending review before sourcing',
        reviewed: 'Pending review before shipping',
        Order: 'Order No.',
        Tripartite: 'Customer Order No. / Internal Order No., separated by commas',
        Product: 'Product name / code',
        SKU: 'SKU',
        source: 'Order Source',
        nickname: 'Buyer nickname',
        name: 'Consignee name',
        mobile: 'Consignee phone number',
        Comments: "Buyer's Comments",
        Merchant: 'Customer Comments',
        have: 'Presence of gifts',
        placement: '3rd Party Order Time',
        Start: 'Start date',
        End: 'End date',
        Payment: 'Payment time',
        Internal: 'Internal Creation Time',
        Approved: 'Approved',
        Approval: 'Rejected',
        deleteCache: 'Delete Cache',
        onOrderRetrieval: 'Retrieve Order',
        Please: 'Please enter Charge Item',
        select: 'Please select the category',
        code: 'Country Code',
        form: {
            Third: 'Customer Order No.',
            Internal: 'CSG Order No.',
            Label: 'Label',
            Approval: 'Review status',
            Sales: 'Store',
            channel: 'Sales Channel',
            Order: 'Order Source',
            Product: 'Number of Item Lines',
            nickname: 'Buyer nickname',
            comments: "Buyer's Comments",
            Merchant: "Merchant's Comments",
            Consignee: 'Consignee name',
            mobile: 'Consignee phone number',
            address: 'Consignee address',
            Status: 'Shipping status',
            Receiving: 'Delivery status',
            Total: 'Total amount of goods',
            payable: 'Amount payable by buyer',
            cost: 'Total cost of goods',
            Three: '3rd Party Order Time',
            Payment: 'Payment time',
            document: 'ERP Order Time',
            Estimated: 'Estimated delivery time',
            Pre: 'Preemptive status',
            Sourcing: 'Sourcing Status',
            Pending: 'Suspend Status',
            occupied: 'Preemptive write-back status',
            Shipment: 'Shipping write-back status',
            there: 'Presence of gifts',
            information: 'Product Information',
            Please: 'Please select review data',
            have: 'You have selected reviewed orders',
            not: 'You do not have permission to review the selected orders',
            Approved: 'Approve Order No.?',
            Reject: 'Reject Order No.?',
            Rejectpst: 'Review rejected',
            Rejectps: 'Reason for not approving',
        }

    }
};
